import * as yup from 'yup';

export const helpCommentFormSchema = yup.object().shape({
    textArea: yup
        .string()
        .trim()
        .max(499, 'El máximo de caracteres permitidos es 500.')
});